export default (fieldValue,fieldName,label,length) => {
    return {
        valid: (!fieldValue || fieldValue.length == length),
        validationText: " חובה להזין "+length+" תוים"
    };
  };